<template>
  <div class="container-fluid">
    <div class="row mt-3">
      <div class="col-6 col-sm-6 col-md-6">
      <form @submit.prevent="submit" >
        <div class="form-group" v-if="errors.length" >
          <ul class="list-group">
            <li class="list-group-item list-group-item-danger" v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </div>
        <div class="form-group input-group-sm">
          <label >Dodaj nową nazwę telefonu</label>
          <input class="form-control" v-model="form.phoneName"/>
        </div>
        <input class="btn btn-success torre-btn btn-sm mr-2" type="submit" value="Zapisz">
        <router-link class="btn btn-secondary btn-sm" :to="{ name: 'main' }">Anuluj</router-link>
      </form>
      </div>
    </div>
  </div>
</template>

<script>
import userService from '@/service/userService'
import axios from 'axios'
import validator from 'validator'
import un from 'underscore'
import appConfig from '@/service/config'
import alertify from 'alertifyjs'

export default {
  name: 'NewPhoneName',
  data: function () {
    return {
      errors: [],
      form: {
        phoneName: ''
      }
    }
  },
  methods: {
    submit: function () {
      const req = axios({
        method: 'post',
        url: appConfig.baseUrl + '/phoneNames',
        data: this.form,
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        alertify.set('notifier','position', 'top-center');
        alertify.success("Telefon został zapisany").delay(3);
        this.errors = []
        this.form.phoneName = ""
      }).catch(err => {
        this.errors = un.map(err.response.data.errors, item => {
          return item.defaultMessage
        })
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/phoneNames/NewPhoneName.vue